import React from 'react';

import EnterpriseRtbList from '../components/enterprise/rtb/list';

class EnterpriseRtbPage extends React.Component{

	render(){

		return (
			<div style={{margin: 16}}>
				<EnterpriseRtbList />
			</div>
		)
	}

}

export default EnterpriseRtbPage;


// WEBPACK FOOTER //
// ./src/containers/enterprise-rtb.js